
































































































































import { Component, Watch } from 'vue-property-decorator';
import auth from '@/services/auth';
import i18n from '@/services/i18n';
import * as common from '../common';
import { ComponentBase, Overlay, Pagination } from '../components';
import { BudgetVariants, FzpReport, Utils } from '../types';
import * as reportsCommon from './common';
import type { Fzp } from './common';


const statusMap: Map<Fzp.StatusCollection, Array<FzpReport.Status>> = new Map([
    ['IN_PROGRESS', ['PLANNED', 'RUNNING', 'FAILED__RETRY_PLANNED']],
    ['EXPORTED', ['FAILED', 'FINISHED_SUCCESSFULLY', 'CANCELLED']],
]);

// 'PLANNED' | 'RUNNING' | 'FAILED' | 'FAILED__RETRY_PLANNED' | 'FINISHED_SUCCESSFULLY' | 'CANCELLED'
const cancellableStatuses: Set<FzpReport.Status> = new Set(['PLANNED', 'RUNNING', 'FAILED__RETRY_PLANNED']);
cancellableStatuses.has('FAILED') && cancellableStatuses.delete('FAILED');


const translates = {
    actions: {
        get cancelGeneration(): string {
            return i18n.choose(
                'Отменить генерацию',
                'Генерацияны болдырмау',
                'Cancel generation',
            );
        },
        get open(): string {
            return i18n.choose(
                'Открыть',
                'Ашық',
                'Open',
            );
        },
        get refresh(): string {
            return i18n.choose(
                'Обновить',
                'Жаңарту',
                'Refresh',
            );
        },
    },
    booleanValues: {
        get no(): string {
            return i18n.choose(
                'Нет',
                'Жоқ',
                'No',
            );
        },
        get yes(): string {
            return i18n.choose(
                'Да',
                'Иә',
                'Yes',
            );
        },
    },
    errors: {
        get cannotCancelReport(): string {
            return i18n.choose(
                'Не удалось отменить генерацию отчета',
                'Есеп жасауды тоқтату сәтсіз аяқталды',
                'Cannot cancel report generation',
            );
        },
    },
    fields: {
        budgetVariantUuid: {
            get title(): string {
                return i18n.choose(
                    'Вариант бюджета',
                    'Бюджеттік нұсқасы',
                    'Budget variant',
                );
            },
        },
        cancelRequested: {
            get title(): string {
                return i18n.choose(
                    'Запрошена отмена генерации отчета',
                    'Есеп жасауды тоқтату сұралды',
                    'Report generation cancellation requested',
                );
            },
        },
        creationMoment: {
            get title(): string {
                return i18n.choose(
                    'Дата и время создания',
                    'Құрылған күні мен уақыты',
                    'Creation date and time',
                );
            },
        },
        id: {
            get title(): string {
                return i18n.choose(
                    'ID',
                    'ID',
                    'ID',
                );
            },
        },
        newArrivals: {
            get title(): string {
                return i18n.choose(
                    'Новоприбывшие',
                    'Жаңа келгендер',
                    'New arrivals',
                );
            },
        },
        regionCode: {
            get title(): string {
                return i18n.choose(
                    'Код региона',
                    'Аймақ коды',
                    'Region code',
                );
            },
        },
        regionName: {
            get title(): string {
                return i18n.choose(
                    'Название региона',
                    'Аймақтың атауы',
                    'Region name',
                );
            },
        },
        reportDate: {
            get title(): string {
                return i18n.choose(
                    'Дата отчета',
                    'Есеп беру күні',
                    'Report date',
                );
            },
        },
        reportType: {
            get title(): string {
                return i18n.choose(
                    'Тип отчета',
                    'Есеп түрі',
                    'Report type',
                );
            },
            values: {
                get ALL(): string {
                    return i18n.choose(
                        'Все',
                        'Барлығы',
                        'All',
                    );
                },
                get CIVIL(): string {
                    return i18n.choose(
                        'Гражданские служащие',
                        'Мемлекеттік қызметкерлер',
                        'Civil servants',
                    );
                },
                get GOV(): string {
                    return i18n.choose(
                        'Административные служащие',
                        'Әкімшілік қызметкерлер',
                        'Administrative employees',
                    );
                },
                get MVD(): string {
                    return i18n.choose(
                        'Служащие МВД',
                        'ІІМ қызметкерлері',
                        'Ministry of Internal Affairs employees',
                    );
                },
            },
        },
        reportYear: {
            get title(): string {
                return i18n.choose(
                    'Год отчета',
                    'Есеп беру жылы',
                    'Report year',
                );
            },
        },
        republicBudget: {
            get title(): string {
                return i18n.choose(
                    'РБ',
                    'РБ',
                    'RB',
                );
            },
        },
        status: {
            get title(): string {
                return i18n.choose(
                    'Статус',
                    'Мәртебесі',
                    'Status',
                );
            },
            values: {
                get CANCELLED(): string {
                    return i18n.choose(
                        'Отменено',
                        'Болдырылмады',
                        'Cancelled',
                    );
                },
                get FAILED(): string {
                    return i18n.choose(
                        'Ошибка формирования',
                        'Қалыптастыру қатесі',
                        'Generation error',
                    );
                },
                get FAILED__RETRY_PLANNED(): string {
                    return i18n.choose(
                        'Не выполнено, ожидается повторная попытка',
                        'Орындалмады, қайта орындау күтілуде',
                        'Not finished, retry planned',
                    );
                },
                get FINISHED_SUCCESSFULLY(): string {
                    return i18n.choose(
                        'Завершено успешно',
                        'Сәтті аяқталды',
                        'Completed successfully',
                    );
                },
                get PLANNED(): string {
                    return i18n.choose(
                        'Запланировано',
                        'Жоспарланған',
                        'Planned',
                    );
                },
                get RUNNING(): string {
                    return i18n.choose(
                        'Выполняется',
                        'Орындалуда',
                        'In progress',
                    );
                },
            },
        },
        tryNumber: {
            get title(): string {
                return i18n.choose(
                    'Номер попытки',
                    'Тырысу нөмірі',
                    'Try number',
                );
            },
        },
        userName: {
            get title(): string {
                return i18n.choose(
                    'Пользователь',
                    'Пайдаланушы',
                    'User',
                );
            },
        },
    },
    messages: {
        reportSaved(id: number): string {
            return i18n.choose(
                `Генерация отчета запланирована, ID #${id}`,
                `Есепті жасау жоспарланған, ID #${id}`,
                `Report generation scheduled, ID #${id}`,
            );
        },
        reportCancelled(id: number): string {
            return i18n.choose(
                () => `Генерация отчета #${id} отменена`,
                () => `#${id} есепті жасау тоқтатылды`,
                () => `Generation of report #${id} has been cancelled`,
            )();
        },
    },
    statusCollection: {
        get exported(): string {
            return i18n.choose(
                'Сформированные',
                'Қалыптасқан',
                'Formed',
            );
        },
        get inProgress(): string {
            return i18n.choose(
                'В процессе обработки',
                'Өңдеу процесінде',
                'In progress',
            );
        },
    },
};


const regionCodeUtil = {
    /**
     * "ХХ0000" — это сводный регион по всей области
     */
    xx0000: new RegExp("[1-9]{2}0000"),

    /**
     * "ХХХХ00" - это сводный регион по району и всем его МСУ
     */
    xxxx00: new RegExp("[1-9]{4}00"),

    /**
     * Является ли код региона кодом сводного региона
     *
     * @param code код региона
     */
    isConsolidatedRegionCode(code: string): boolean {
        return regionCodeUtil.xx0000.test(code) || regionCodeUtil.xxxx00.test(code);
    },
};


@Component({
    components: {
        Overlay,
        Pagination,
    },
})
export default class FzpReportListPane extends ComponentBase {
    constructor() {
        super('');
    }


    // region Lifecycle
    protected created() {
        super.created();

        this.$watch('selectedType', () => {
            if (this.page !== 0) {
                this.page = 0;
            } else {
                this.reloadReports();
            }
        });

        this.$watch('itemsPerPage', () => {
            if (!this.applyingReloadReportData) {
                this.reloadReports();
            }
        });

        this.$watch('page', () => {
            if (!this.applyingReloadReportData) {
                this.reloadReports();
            }
        });
    }

    protected mounted() {
        super.mounted();
        this.reloadReports();
    }
    // endregion


    // region Утилиты
    public translates = translates;
    public cancellableStatuses = cancellableStatuses;

    public get debug(): boolean {
        return (common.debugUtilObject.get(common.debugUtilKeys.reports.fzp.debug) == true);
    }


    public get fzpNewReportId(): number | null {
        return reportsCommon.reportRuntimeContext.fzpNewReportId;
    }

    @Watch('fzpNewReportId')
    public onFzpNewReportIdChanged(value: number | null) {
        if (value !== null) {
            this.toast('success', '', this.translates.messages.reportSaved(value));
            if (this.selectedType === 'EXPORTED') {
                this.reloadReports();
            } else {
                this.selectedType = 'EXPORTED';
            }
        }
    }
    // endregion


    // region Переключатель типа
    public selectedType: Fzp.StatusCollection = reportsCommon.reportRuntimeContext.fzpStatusCollection;

    @Watch('selectedType')
    public onSelectedTypeChanged(value: Fzp.StatusCollection) {
        reportsCommon.reportRuntimeContext.fzpStatusCollection = value;
    }
    // endregion


    // region Навигация по страницам
    public itemsPerPage = 25;
    public page = 0;
    public totalItems = 0;

    public onItemsPerPageChanged(itemsPerPage: unknown) {
        this.itemsPerPage = (itemsPerPage as number);
    }
    // endregion


    // region Утилиты
    public get loading(): boolean {
        return this.loadingReports;
    }

    public formatDate(value: number | null): string {
        if (value === null) {
            return '';
        }
        return new Intl.DateTimeFormat('ru', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(new Date(value));
    }

    public formatDateTime(value: number): string {
        return new Intl.DateTimeFormat('ru', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }).format(new Date(value));
    }
    // endregion


    // region Отчеты + варианты бюджета
    public reports: Array<FzpReport> = [];
    public reportBudgetVariantsMap: Record<string, BudgetVariants> = {};
    public loadingReports = false;
    public applyingReloadReportData = false;

    public reloadReports() {
        if (this.loadingReports) {
            console.error('Cannot reload FZP report list - another loading is running');
            return;
        }

        this.loadingReports = true;
        this.reports = [];

        const statusCollection = statusMap.get(this.selectedType)!!;

        const parameterMap: Array<[string, unknown]> = [
            ['items-per-page', this.itemsPerPage],
            ['page-index', this.page],
            ['user-id', auth.user.sub],
        ];
        statusCollection.forEach((status) => {
            parameterMap.push(['status', status]);
        });

        const url = this.prepareUrl(
            '/api/budget/staffing_table/fzp/list',
            parameterMap,
        );

        this.request<Fzp.ReportListResponse>(
            {
                url,
                method: 'GET',
            },
            (data) => {
                this.reports = data.reportList.items;
                this.reportBudgetVariantsMap = data.budgetVariantMap;

                try {
                    this.applyingReloadReportData = true;
                    this.totalItems = data.reportList.itemCount;
                    this.itemsPerPage = data.reportList.itemsPerPage;
                    this.page = data.reportList.page;
                } finally {
                    this.applyingReloadReportData = false;
                }
            },
            undefined,
            () => {
                this.loadingReports = false;
            },
        );
    }

    public cancelReport(report: FzpReport) {
        console.log('cancelReport', report);
        if (this.loadingReports) {
            console.error('Cannot cancel report - another loading is running');
            return;
        }

        this.loadingReports = true;

        const id = report.id;
        if (id === null) {
            console.error('Cannot cancel report - report has no ID');
            return;
        }

        this.request<unknown>(
            {
                url: `/api/budget/staffing_table/fzp/cancel-report?id=${id}`,
                method: 'POST',
            },
            () => {
                this.toast(
                    'success',
                    '',
                    this.translates.messages.reportCancelled(id),
                );
            },
            () => this.translates.errors.cannotCancelReport,
            () => {
                this.loadingReports = false;
                this.reloadReports();
            },
        );
    }

    public openReport(report: FzpReport) {
        this.$router.push({
            path: `/staffing-table/fzp-report/${report.id}`,
        });
    }

    public downloadDebugContent(report: FzpReport) {
        this.openUrl(`/api/budget/staffing_table/fzp/debug-text/${report.id}.txt`, '_blank', false);
    }

    public getReportBudgetVariantText(report: FzpReport): string {
        const budgetVariantUuid = report.budgetVariantUuid ?? '';

        const budgetVariant = this.reportBudgetVariantsMap[budgetVariantUuid] ?? null;

        if (budgetVariant === null) {
            return budgetVariantUuid;
        } else {
            return i18n.choose(
                budgetVariant.nameRu,
                budgetVariant.nameKk ?? budgetVariant.nameRu,
                budgetVariant.nameEn ?? budgetVariant.nameRu,
            );
        }
    }

    public getReportDate(report: FzpReport): number | null {
        if (regionCodeUtil.isConsolidatedRegionCode(report.regionCode)) {
            return report.reportDate;
        } else {
            return report.creationMoment;
        }
    }
    // endregion
}
